import { render } from "./SliderComp.vue?vue&type=template&id=7e5fa8a8"
import script from "./SliderComp.vue?vue&type=script&lang=js"
export * from "./SliderComp.vue?vue&type=script&lang=js"

import "./SliderComp.vue?vue&type=style&index=0&id=7e5fa8a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__